<template>
  <b-form-group>
    <treeselect
      ref="treeselect"
      v-model="selected"
      multiple
      :options="treeOptions"
      :placeholder="treeTitle"
      :disabled="disabled || busy"
      :before-clear-all="onBeforeClearAll"
      :close-on-select="false"
      @close="onClose"
    >
      <div slot="before-list">
        <b-row class="border-bottom">
          <b-col class="font-italic">
            <a class="ml-2" href="#" @click.prevent="onTreeSelectAll">
              <small>{{ trans('select_all') }}</small>
            </a>
          </b-col>
          <b-col class="font-italic">
            <a class="mr-2" href="#" @click.prevent="onTreeClearAll">
              <small>{{ trans('unselect_all') }}</small>
            </a>
          </b-col>
        </b-row>
      </div>
      <div slot="option-label" slot-scope="{ node }">
        <span>
          {{ node.label }}
          <small class="text-muted">
            ({{ node.raw.participant_count }}
            {{ trans('participant' + (node.raw.participant_count > 1 || node.raw.participant_count  == 0 && lang == 'en' ? 's' : '')).toLowerCase() }}
            {{ trans('in') }}
            {{ node.raw.class_count }}
            {{ trans('class' + (node.raw.class_count > 1 || node.raw.class_count  == 0 && lang == 'en' ? 'es' : '')).toLowerCase() }})
          </small>
        </span>
      </div>
      <div slot="value-label" slot-scope="{ node }" style="white-space: normal;">
        <i class="fa fa-fw fa-tag"></i>
        {{ node.label }}
      </div>
    </treeselect>
  </b-form-group>
</template>

<script>
  import Treeselect from '@riophae/vue-treeselect'

  export default {
    props: {
      organization: Object,
      value: Array,
      disabled: {
        type: Boolean,
        default: false,
      },
      placeholder: {
        type: String,
        default: trans('choose_a_tag'),
      },
      allClasses: Array,
    },
    components: {
      Treeselect,
    },
    data() {
      return {
        trans: trans,
        lang: lang,
        busy: false,
        error: null,
        selected: this.value ? _.clone(this.value) : [],
        all_classes: this.allClasses,
        // filter
        tag: null,
      }
    },
    computed: {
      treeTitle() {
        return !this.isLoading ? trans('select_tags') : trans('please_wait')
      },
      treeOptions() {
        return _.reduce(this.all_classes || [], (options, cls) => {
          return _.reduce(cls.tags || [], (options, tag) => {
            let found = _.find(options, {id: tag.name})
            if (found) {
              found.class_count += 1
              found.participant_count += cls.participant_count
            } else {
              options.push({
                id: tag.name,
                label: tag.name,
                class_count: 1,
                participant_count: cls.participant_count
              })
            }
            return options
          }, options)
        }, [])
      },
      participantCount() {
        return _.reduce(this.all_classes || [], (count, cls) => {
          let found = (_.reduce(cls.tags || [], (found, tag) => {
            if ((this.selected || []).indexOf(tag.name) >= 0) found = true
            return found
          }, false))
          if (found) count += cls.participant_count
          return count
        }, 0)
      },
      classCount() {
        return _.reduce(this.all_classes || [], (count, cls) => {
          let found = (_.reduce(cls.tags || [], (found, tag) => {
            if ((this.selected || []).indexOf(tag.name) >= 0) found = true
            return found
          }, false))
          if (found) count += 1
          return count
        }, 0)
      },
    },
    watch: {
      allClasses() {
        this.all_classes = this.allClasses
      },
      value() {
        this.selected = this.value ? _.clone(this.value) : []
      },
    },
    methods: {
      onTreeSelectAll(index) {
        this.selected.splice(0, this.selected.length)
        let visibleIds = this.getSelectedOptionIds()
        this.treeOptions.forEach(option => {
          if (visibleIds.indexOf(option.id) >= 0) this.selected.push(option.id)
        })
      },
      getSelectedOptionIds() {
        let visibleIds = [];
        this.$refs
          .treeselect
          .$el.querySelectorAll('.vue-treeselect__option:not(.vue-treeselect__option--hide)')
          .forEach(el => {
            if (el && el.dataset && el.dataset.id) visibleIds.push(parseInt(el.dataset.id, 10))
          })
        return visibleIds
      },
      onTreeClearAll(index) {
        if (this.selected) this.selected.splice(0, this.selected.length)
      },
      onBeforeClearAll() {
        this.$nextTick(() => {
          this.$emit('input', [])
          this.$emit('participant-count', 0)
          this.$emit('class-count', 0)
        })
        return true
      },
      onClose() {
        if (!_.isEqual(this.selected, this.value)) {
          this.$emit('input', this.selected)
          this.$emit('participant-count', this.participantCount)
          this.$emit('class-count', this.classCount)
        }
      },
      fetch() {
        this.busy = true
        this.error = null
        let url = `/organization/${this.organization.id}/event/ll`
        return axios.get(url)
        .then(response => {
          this.busy = false
          this.all_classes = response.data
          this.$emit('all-classes', response.data)
        })
        .catch(error => {
          this.busy = false
          this.error = _.errorFromAjax(error)
        })
      },
    },
    mounted() {
      window.classMultiselect = this
      if (this.all_classes == null) this.fetch()
    },
  }
</script>